import WindowStore from '@/store/window'

export default defineNuxtPlugin((nuxtApp) => {
  
  (nuxtApp.$router as any).beforeEach((to: any, from: any, next: any) => {
    const windowStore = WindowStore()
    const { isLockNavigation } = storeToRefs(windowStore)

    if (isLockNavigation.value) {
      isLockNavigation.value = false
      next(false) 
      return ''
    }

    if (from.name) windowStore.setScroll(from.name as string, window.scrollY)

    next()
  })

  // nuxtApp.$router.afterEach((to: any, from: any) => {
  //   const windowStore = WindowStore()
  //   const { scrolls } = storeToRefs(windowStore)
    
  //   setTimeout(() => window.scrollTo({ top: scrolls.value.get(to.name as string) ?? 0, behavior: 'instant' }))
  // })

  return true
})
